import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (default_image, t) => [
    {
        label: t('discover.pages.table.page'),
        key: 'page',
        data: 'page',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            let title = item.title;

            if (!item.title) {
                title = item.page;
            }

            if (csvDownload) return title;

            return (
                <div>
                    <div className="d-flex align-items-center">
                        <div style={{ display: 'contents' }}>
                            <img
                                onError={(event) => (event.target.src = default_image)}
                                src={item.image ?? default_image}
                                style={{
                                    background: '#BBB',
                                    width: '70px',
                                    borderRadius: '8px',
                                    objectFit: 'cover',
                                }}
                                alt="page_image"
                                loading="lazy"
                            />
                        </div>
                        <div style={{ marginLeft: '8px' }}>
                            <strong>
                                <a
                                    href={
                                        `/domains/${window.info.id}/pages/page?page=` +
                                        encodeURIComponent(item.page)
                                    }
                                >
                                    {title}
                                    {/* {title.length > 64 ? title.substr(0, 64) + '...' : title} */}
                                </a>
                            </strong>
                            <a
                                target="_blank"
                                className="link-website d-inline-flex align-items-center justify-content-center"
                                href={item.page}
                                rel="noreferrer"
                            >
                                <i className="icon-external-link"></i>
                            </a>
                        </div>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('discover.pages.table.uniques'),
        key: 'uniques',
        data: 'uniques',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <span title={item.uniqueHeadlines?.join(' , ')} className="cursor-pointer">
                    {data}
                </span>
            );
        },
    },
    {
        label: t('discover.pages.table.age'),
        key: 'age',
        data: 'age',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <strong>{numeral(data).format('0,00')} Days</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.pages.table.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.pages.table.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.pages.table.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.clicks / item.impressions;
            if (csvDownload) return ctrValue;

            return (
                <div>
                    <strong>{numeral(ctrValue).format('0.00%')}</strong>{' '}
                </div>
            );
        },
    },
];

export const FIELD_FOR_DOWNLOADS = (t) => [
    {
        label: t('discover.pages.table.uniqueHeadlines'),
        key: 'uniqueHeadlines',
        data: 'uniqueHeadlines',
        Component: Cell,
        renderCell: ({ data }) => {
            return (Array.isArray(data) ? data.join(' , ') : data).trim();
        },
    },
    {
        label: t('discover.pages.table.page_url'),
        key: 'page_url',
        data: 'page_url',
        Component: Cell,
        renderCell: ({ item }) => {
            return item.page;
        },
    },
];
